export default __webpack_public_path__ + "static/media/wifi-3.0519f329.svg";